/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Color from "../../utils/Color";
import { intl } from "../../services/intlGlobalProvider";

const StyledContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const StyledBackButton = styled(Link)`
  margin-top: 10px;
  padding: 10px 15px;
  background: ${Color.Primary};
  border-radius: 5px;
  color: white;
  font-size: 0.9em;
  box-shadow: 0 4px 6px -5px grey;
`;

const StyledImg = styled.img`
  width: 100%;
  height: auto;
`;

class NotFoundPage extends Component {
  render() {
    return (
      <StyledContainer>
        <StyledImg src={require("../../assets/404_1.png")} alt="Not Found" />
        <StyledBackButton to="/shop" className="opacity underline">
          {intl.formatMessage({ id: "app.back.home" })}
        </StyledBackButton>
      </StyledContainer>
    );
  }
}

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/containers/NotFoundPage/index.js